
import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import FormCard from '~/components/atoms/Card.vue'
import Button from '~/components/atoms/Button.vue'
import InputBox from '~/components/molecules/InputBox.vue'
import Alert from '~/components/atoms/Alert.vue'
import Information from '~/components/atoms/Information.vue'
import Separator from '~/components/atoms/Separator.vue'
import AuthContainer from '~/components/organisms/AuthContainer.vue'
import AuthServiceList from '~/components/organisms/AuthServiceList.vue'

import errorcode from '~/consts/errorcode'
import { AuthApiUrl } from '~/server/api/route/url'

localize('ja', ja)

extend('email', {
  ...email,
})
extend('required', {
  ...required,
})

export default Vue.extend({
  components: {
    FormCard,
    Button,
    InputBox,
    Separator,
    Alert,
    Information,
    ValidationProvider,
    ValidationObserver,
    AuthContainer,
    AuthServiceList,
  },
  layout: 'public',
  data() {
    return {
      error: null,
      registerForm: {
        email: '',
      },
    }
  },
  methods: {
    async issueCode() {
      try {
        const observer = this.$refs.obs as InstanceType<typeof ValidationObserver>
        if (!(await observer.validate())) {
          this.$data.error = 'フォームに正しく入力してください'
          return
        }
        if (this.$store.state.authUser) {
          await this.$axios.$post(AuthApiUrl.LOGOUT)
        }

        const email = this.$data.registerForm.email
        const res = await this.$axios.$post(AuthApiUrl.ISSUE_REGISTER_CODE, { email })

        if (res.status !== 200) {
          if (res.errorcode === errorcode.AUTH_DUPLICATED_GOOGLE) {
            window.location.href = '/discover_sexualities/auth/register/error?provider=Google'
          } else if (res.errorcode === errorcode.AUTH_DUPLICATED_TWITTER) {
            window.location.href = '/discover_sexualities/auth/register/error?provider=Twitter'
          } else if (res.errorcode === errorcode.AUTH_DUPLICATED_JOBRAINBOW) {
            window.location.href = '/discover_sexualities/auth/register/error'
          } else {
            this.$data.error = '新規登録できませんでした。JobRainbowをご利用の方はログインをお試しください。'
          }

          return
        }

        window.location.href = `/discover_sexualities/auth/register/verify/code`
      } catch (_) {
        this.$data.error = '新規登録できませんでした。JobRainbowをご利用の方はログインをお試しください。'
      }
    },
  },
})
